import { Modal } from "react-bootstrap";
import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useGetAllAccountMutation } from "../../redux-toolkit/services/accountMasterService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { getAllAccountMasterList, setAllAccountMaster } from "../../redux-toolkit/slices/accountMasterSlice";
import { useGetOpeningBalanceFinanceByIdMutation, useSaveOpeningBalanceFinanceMutation, useUpdateOpeningBalanceFinanceMutation, useUploadBulkOpeningBalanceFinanceMutation } from "../../redux-toolkit/services/openingBalanceFinanceService";
import { useGetOpeningBalanceKarmaByIdMutation, useSaveOpeningBalanceKarmaMutation, useUpdateOpeningBalanceKarmaMutation, useUploadBulkOpeningBalanceKarmaMutation } from "../../redux-toolkit/services/openingBalanceKarmaService";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useBulkSaveAuditLogMutation, useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};

const OpeningBalanceReportsData = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");


    //save
    const [saveOpeningBalanceFinanceMaster, saveOpeningBalanceFinanceMasterResponse] = useSaveOpeningBalanceFinanceMutation();
    const [saveOpeningBalanceKarmaMaster, saveOpeningBalanceKarmaMasterResponse] = useSaveOpeningBalanceKarmaMutation();
    const [logAudit] = useSaveAuditLogMutation();
    const [logAuditBulk] = useBulkSaveAuditLogMutation();
    //bulk
    const [bulkSaveOpeningBalanceFinanceMaster, bulkSaveOpeningBalanceFinanceMasterResponse] = useUploadBulkOpeningBalanceFinanceMutation();
    const [bulkSaveOpeningBalanceKarmaMaster, bulkSaveOpeningBalanceKarmaMasterResponse] = useUploadBulkOpeningBalanceKarmaMutation();

    //update
    const [updateOpeningBalanceFinanceMaster, updateOpeningBalanceFinanceMasterResponse] = useUpdateOpeningBalanceFinanceMutation();
    const [updateOpeningBalanceKarmaMaster, updateOpeningBalanceKarmaMasterResponse] = useUpdateOpeningBalanceKarmaMutation();


    //getById mutation
    const [getOpeningBalanceFinanceMasterById, openingBalanceFinanceMasterByIdResponse] = useGetOpeningBalanceFinanceByIdMutation();
    const [getOpeningBalanceKarmaMasterById, openingBalanceKarmaMasterByIdResponse] = useGetOpeningBalanceKarmaByIdMutation();


    //getAllData
    const [findAllAccountMasters, findAllAccountMastersResponse] = useGetAllAccountMutation();

    //Data
    const allAccountMasterData: any = useAppSelector(getAllAccountMasterList);


    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
                getOpeningBalanceFinanceMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                findAllAccountMasters({
                    token: localUserObj?.token
                })
            } else if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
                getOpeningBalanceKarmaMasterById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                });
                findAllAccountMasters({
                    token: localUserObj?.token
                })
            }

        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
                findAllAccountMasters({
                    token: localUserObj?.token
                })

            } else if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
                findAllAccountMasters({
                    token: localUserObj?.token
                })
            }


        }
    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };


    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
                const payload = {
                    accountCode: values.accountCode,
                    amount: values.amount,
                    asOfDate: values.asOfDate,
                    sourceType: values.sourceType || "ManualEntry",
                    isActive: values.isActive,
                };

                saveOpeningBalanceFinanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });

            } else if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {

                const payload = {
                    accountCode: values.accountCode,
                    tokenValue: values.tokenValue,
                    asOfDate: values.asOfDate,
                    sourceType: values.sourceType || "ManualEntry",
                    isActive: values.isActive,
                };

                saveOpeningBalanceKarmaMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            }

        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {

            if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {

                const payload = {
                    id: props?.data?.id,
                    accountCode: values.accountCode,
                    amount: values.amount,
                    asOfDate: values.asOfDate,
                    sourceType: values.sourceType,
                    isActive: true,
                };

                updateOpeningBalanceFinanceMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });

            } else if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {

                const payload = {
                    id: props?.data?.id,
                    accountCode: values.accountCode,
                    tokenValue: values.tokenValue,
                    asOfDate: values.asOfDate,
                    sourceType: values.sourceType,
                    isActive: true,
                };

                updateOpeningBalanceKarmaMaster({
                    token: localUserObj?.token,
                    payload: payload,
                    id: props?.data?.id,
                });
            }
        }
    };

    useEffect(() => {
        if (openingBalanceFinanceMasterByIdResponse.isSuccess) {
            setGetByIdData(openingBalanceFinanceMasterByIdResponse.data);
        } else if (openingBalanceFinanceMasterByIdResponse.isError) {
            let response: any = openingBalanceFinanceMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [openingBalanceFinanceMasterByIdResponse.isSuccess, openingBalanceFinanceMasterByIdResponse.isError]);

    useEffect(() => {
        if (openingBalanceKarmaMasterByIdResponse.isSuccess) {
            setGetByIdData(openingBalanceKarmaMasterByIdResponse.data);
        } else if (openingBalanceKarmaMasterByIdResponse.isError) {
            let response: any = openingBalanceKarmaMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [openingBalanceKarmaMasterByIdResponse.isSuccess, openingBalanceKarmaMasterByIdResponse.isError]);



    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };


    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
                bulkSaveOpeningBalanceFinanceMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            } else if (props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
                bulkSaveOpeningBalanceKarmaMaster({
                    payload: formData,
                    token: localUserObj?.token
                });
            }

        }
    }

    // bulk save - Finance
    useEffect(() => {
        if (bulkSaveOpeningBalanceFinanceMasterResponse.isSuccess) {
            const response: any = bulkSaveOpeningBalanceFinanceMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Opening Balance Master - Finance uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveOpeningBalanceFinanceMasterResponse.isError) {
            const response: any = bulkSaveOpeningBalanceFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveOpeningBalanceFinanceMasterResponse.isSuccess,
        bulkSaveOpeningBalanceFinanceMasterResponse.isError
    ]);

    // bulk save - Karma
    useEffect(() => {
        if (bulkSaveOpeningBalanceKarmaMasterResponse.isSuccess) {
            const response: any = bulkSaveOpeningBalanceKarmaMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_KARMA,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Opening Balance Master - Karma uploaded successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveOpeningBalanceKarmaMasterResponse.isError) {
            const response: any = bulkSaveOpeningBalanceKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        bulkSaveOpeningBalanceKarmaMasterResponse.isSuccess,
        bulkSaveOpeningBalanceKarmaMasterResponse.isError
    ]);

    // find all accounts
    useEffect(() => {
        if (findAllAccountMastersResponse.isSuccess) {
            console.log(findAllAccountMastersResponse, "findAllAccountMastersResponse");
            dispatch(setAllAccountMaster(findAllAccountMastersResponse));
        } else if (findAllAccountMastersResponse.isError) {
            let response: any = findAllAccountMastersResponse.error;
            alertMessage(response, "error");
        }
    }, [
        findAllAccountMastersResponse.isSuccess,
        findAllAccountMastersResponse.isError
    ]);

    // save - Finance
    useEffect(() => {
        if (saveOpeningBalanceFinanceMasterResponse.isSuccess) {

            const response: any = saveOpeningBalanceFinanceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Opening Balance Master - Finance added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveOpeningBalanceFinanceMasterResponse.isError) {
            const response: any = saveOpeningBalanceFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        saveOpeningBalanceFinanceMasterResponse.isSuccess,
        saveOpeningBalanceFinanceMasterResponse.isError
    ]);

    // save - Karma
    useEffect(() => {
        if (saveOpeningBalanceKarmaMasterResponse.isSuccess) {
            const response: any = saveOpeningBalanceKarmaMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_KARMA,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Opening Balance Master - Karma added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveOpeningBalanceKarmaMasterResponse.isError) {
            const response: any = saveOpeningBalanceKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        saveOpeningBalanceKarmaMasterResponse.isSuccess,
        saveOpeningBalanceKarmaMasterResponse.isError
    ]);

    useEffect(() => {
        if (updateOpeningBalanceFinanceMasterResponse.isSuccess) {
            const response: any = updateOpeningBalanceFinanceMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: openingBalanceFinanceMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Opening Balance Master - Finance updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateOpeningBalanceFinanceMasterResponse.isError) {
            const response: any = updateOpeningBalanceFinanceMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updateOpeningBalanceFinanceMasterResponse.isSuccess,
        updateOpeningBalanceFinanceMasterResponse.isError
    ]);

    useEffect(() => {
        if (updateOpeningBalanceKarmaMasterResponse.isSuccess) {
            const response: any = updateOpeningBalanceKarmaMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_KARMA,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: openingBalanceKarmaMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Opening Balance Master - Karma updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateOpeningBalanceKarmaMasterResponse.isError) {
            const response: any = updateOpeningBalanceKarmaMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [
        updateOpeningBalanceKarmaMasterResponse.isSuccess,
        updateOpeningBalanceKarmaMasterResponse.isError
    ]);


    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                // dialogClassName={"modal-90w"}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" } // default to lg for all others
                )}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold text-accent" style={{ fontSize: "1rem" }}>
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                            openingBalanceFinanceMasterByIdResponse.isLoading ||
                            openingBalanceKarmaMasterByIdResponse.isLoading ||
                            saveOpeningBalanceFinanceMasterResponse.isLoading ||
                            saveOpeningBalanceKarmaMasterResponse.isLoading ||
                            bulkSaveOpeningBalanceFinanceMasterResponse.isLoading ||
                            bulkSaveOpeningBalanceKarmaMasterResponse.isLoading ||
                            updateOpeningBalanceFinanceMasterResponse.isLoading ||
                            updateOpeningBalanceKarmaMasterResponse.isLoading
                            ? (
                                <Loading />
                            ) : (
                                ""
                            )}

                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active text-accent' : 'text-secondary'}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}

                    {activeTab === "manual" && (
                        <Formik
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE
                                    ? {
                                        id: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                        accountCode: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountCode || "" : "",
                                        amount: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.amount || "" : "",
                                        asOfDate: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.asOfDate || "" : "",
                                        sourceType: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.sourceType || "" : "",
                                        isActive: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                    }
                                    : props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA
                                        ? {
                                            id: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.id || "" : "",
                                            accountCode: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.accountCode || "" : "",
                                            tokenValue: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.tokenValue || "" : "",
                                            asOfDate: props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData?.asOfDate || "" : "",
                                            sourceType: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.sourceType || "" : "",
                                            isActive: props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData?.isActive ?? true : true,
                                        }
                                        : {}
                            }

                            onSubmit={handleSubmit}
                        >
                            {({ values, setFieldValue, handleChange }) => (
                                <Form>
                                    <div>
                                        {props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE ? (
                                            <div className="row g-3">
                                                {/* Account Code */}
                                                <div className="col-12">
                                                    <label className="form-label">
                                                        Account Code <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="accountCode"
                                                        value={values.accountCode}
                                                        onChange={(e) => setFieldValue("accountCode", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Account</option>
                                                        {allAccountMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.accountName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Amount */}
                                                <div className="col-12">
                                                    <label className="form-label mt-1">Amount</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="amount"
                                                        value={values.amount}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>

                                                {/* As of Date */}
                                                <div className="col-12">
                                                    <label className="form-label mt-1">As of Date</label>
                                                    <DatePicker
                                                        className="w-100"
                                                        format="YYYY-MM-DD"
                                                        required
                                                        value={values.asOfDate ? dayjs(values.asOfDate, "YYYY-MM-DD") : null}
                                                        onChange={(date) =>
                                                            setFieldValue("asOfDate", date ? date.format("YYYY-MM-DD") : "")
                                                        }
                                                        getPopupContainer={(trigger) =>
                                                            (trigger.parentNode as HTMLElement) || document.body
                                                        }
                                                    />
                                                </div>

                                                {/* Source Type */}
                                                <div className="col-12">
                                                    <label className="form-label mt-1">Source Type</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="sourceType"
                                                        value={values.sourceType}
                                                        onChange={(e) => setFieldValue("sourceType", e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        ) : props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA ? (
                                            <div className="row g-3">
                                                {/* Account Code */}
                                                <div className="col-12">
                                                    <label className="form-label">
                                                        Account Code <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        name="accountCode"
                                                        value={values.accountCode}
                                                        onChange={(e) => setFieldValue("accountCode", e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Select Account</option>
                                                        {allAccountMasterData.map((item: any, idx: number) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.id} - {item.accountName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Token Value */}
                                                <div className="col-12">
                                                    <label className="form-label mt-1">Token Value</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="tokenValue"
                                                        value={values.tokenValue}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>

                                                {/* As of Date */}
                                                <div className="col-12">
                                                    <label className="form-label mt-2">As of Date</label>
                                                    <DatePicker
                                                        className="w-100"
                                                        format="YYYY-MM-DD"
                                                        required
                                                        value={values.asOfDate ? dayjs(values.asOfDate, "YYYY-MM-DD") : null}
                                                        onChange={(date) =>
                                                            setFieldValue("asOfDate", date ? date.format("YYYY-MM-DD") : "")
                                                        }
                                                        getPopupContainer={(trigger) =>
                                                            (trigger.parentNode as HTMLElement) || document.body
                                                        }
                                                    />
                                                </div>

                                                {/* Source Type */}
                                                <div className="col-12">
                                                    <label className="form-label mt-1">Source Type</label>
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="text"
                                                        name="sourceType"
                                                        value={values.sourceType}
                                                        onChange={(e) => setFieldValue("sourceType", e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="d-flex flex-row justify-content-center">
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                        >
                                            {props.actionType === ACTION_TYPE.ADD_ACTION ? "Save" : "Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE
                                    ? "OPENING_BALANCE_MASTER_FINANCE"
                                    : props.reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA
                                        ? "OPENING_BALANCE_MASTER_KARMA"
                                        : ""
                                    }.xlsx`}

                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );

};

export default OpeningBalanceReportsData